import { Route, Routes, Navigate } from 'react-router-dom';
import { SignedIn, SignedOut, SignIn, SignUp } from '@clerk/clerk-react';

import CardList from './CardList';

function Router() {
  return (
    <Routes>
      <Route
        path='/signin/*'
        element={
          <div>
            <SignIn routing='path' path='/signin' redirectUrl={'/'} signUpUrl={'/signup'} />
          </div>
        }
      />
      <Route
        path='/signup/*'
        element={
          <div>
            <SignUp routing='path' path='/signup' redirectUrl={'/'} signInUrl={'/signin'} />
          </div>
        }
      />

      <Route
        path='*'
        element={
          <>
            <SignedOut>
              <Navigate to='/signin' replace={true} />
            </SignedOut>
            <SignedIn>
              <CardList></CardList>
            </SignedIn>
          </>
        }
      />
    </Routes>
  );
}

export default Router;
